// ----------------------------------------------------------------------------
// Component: Contest Prize
// ----------------------------------------------------------------------------
//
// A list of contest prize cards
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Scrollbar, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import './_contest-prize.scss';




// -------------------------------------
// Hooks
// -------------------------------------
function handleContestCardSlides(swiperEl) {
  swiperEl.slides.forEach(function (slide, index) {
    let slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function (e) {
      swiperEl.slideTo(index);
    })
  });
}

$(function () {
  $(".carousel--contest-card").each(function (index, element) {
    var $this = $(this);

    // Generate unique class for each feature card slider
    $this.addClass("contest-card-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.contest-prize-list').find(".swiper-scrollbar").addClass("contest-card-swiper-scrollbar-" + index);

    // Initialize feature card slider based on the unique classes generated above.
    var swiper = new Swiper(".contest-card-instance-" + index, {
      // Optional parameters
      modules: [Scrollbar, A11y],
      slidesPerView: 1.2,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      a11y: false,
      watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
      centerInsufficientSlides: true,
      breakpoints: {
        // when window width is >= 680px
        680: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },

      scrollbar: {
        el: ".contest-card-swiper-scrollbar-" + index,
        draggable: true,
      }
    });

    swiper.slides.forEach(function(slide, index) {
      slide.addEventListener('focus', function(e) {
          swiper.slideTo(index);
        })
    });
  });
});

